// Cronometro de trabajo: uno por persona y navegador. Sigue corriendo al cambiar de pantalla o recargar; al detenerlo
// se abre el registro de horas con los minutos ya puestos.
import { useSyncExternalStore } from 'react';

import { readJSON, writeJSON } from './storage';

export type Cronometro = { inicio: number; etiqueta: string; proyectoId?: string | null; casoId?: string | null } | null;

const CLAVE = 'consola.cronometro';
let actual: Cronometro = readJSON<Cronometro>(CLAVE, null);
const oyentes = new Set<() => void>();
const avisar = () => oyentes.forEach((f) => f());

export function iniciarCronometro(c: Omit<NonNullable<Cronometro>, 'inicio'>) {
  actual = { ...c, inicio: Date.now() };
  writeJSON(CLAVE, actual);
  avisar();
}

// Devuelve lo que se estaba cronometrando y los minutos transcurridos (minimo 1).
export function detenerCronometro() {
  const c = actual;
  actual = null;
  writeJSON(CLAVE, null);
  avisar();
  return c ? { ...c, minutos: minutosDesde(c.inicio) } : null;
}

export const minutosDesde = (inicio: number, ahora = Date.now()) => Math.max(1, Math.round((ahora - inicio) / 60_000));

export const useCronometro = () =>
  useSyncExternalStore(
    (f) => (oyentes.add(f), () => oyentes.delete(f)),
    () => actual,
  );
